import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AccountService} from '../auth/account.service';


@Directive({
    selector: '[dmpHasAnyAuthorityMenu]',
    standalone: false
})
export class HasAnyAuthorityMenuDirective {

    private menus: string[];

    constructor(private accountService: AccountService,
                private templateRef: TemplateRef<unknown>,
                private viewContainerRef: ViewContainerRef) {
    }

    @Input()
    set dmpHasAnyAuthorityMenu(value: string | string[]) {
        this.menus = typeof value === 'string' ? [value] : value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.accountService.getAuthenticationState().subscribe(() => this.updateView());
    }

    private updateView(): void {
        const hasAnyAuthority = this.accountService.hasAnyMenu(this.menus);
        this.viewContainerRef.clear();
        if (hasAnyAuthority) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }

}
